import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Tenants.css';
import tenantsVisualBreak from '../assets/tenants-visual-break.png';

const Tenants = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const [status, setStatus] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('sending');

        const formData = new FormData(e.target);
        const object = Object.fromEntries(formData);
        const json = JSON.stringify(object);

        console.log("Sending maintenance data:", object);

        try {
            const response = await fetch("https://formsubmit.co/ajax/cindy@pcpropertymgmt.com", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },
                body: json
            });

            const result = await response.json();
            console.log("Email API Response:", result);

            if (response.ok) {
                setStatus('success');
                e.target.reset();
            } else {
                setStatus('error');
            }
        } catch (error) {
            console.error("Email Error:", error);
            setStatus('error');
        }
    };

    // SVG Icon Components
    const PortalIcon = () => (
        <svg className="tenant-icon" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="32" cy="32" r="30" fill="#0A192F" stroke="#D4AF37" strokeWidth="2" />
            <rect x="18" y="20" width="28" height="24" rx="2" stroke="#FFFFFF" strokeWidth="2" />
            <path d="M22 28H42" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" />
            <path d="M22 36H36" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" />
            <circle cx="26" cy="20" r="4" fill="#0A192F" stroke="#D4AF37" strokeWidth="2" />
        </svg>
    );

    const ApplicationIcon = () => (
        <svg className="tenant-icon" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="32" cy="32" r="30" fill="#0A192F" stroke="#D4AF37" strokeWidth="2" />
            <path d="M22 18H42" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" />
            <path d="M22 26H38" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" />
            <path d="M22 34H42" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" />
            <path d="M22 42H34" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" />
            <path d="M44 40L48 44L54 34" stroke="#D4AF37" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
            <rect x="16" y="14" width="32" height="36" rx="2" stroke="#D4AF37" strokeWidth="2" />
        </svg>
    );

    const MaintenanceIcon = () => (
        <svg className="tenant-icon" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="32" cy="32" r="30" fill="#0A192F" stroke="#D4AF37" strokeWidth="2" />
            <path d="M26 38L22 42L26 46L30 42L26 38Z" fill="#FFFFFF" />
            <rect x="24" y="20" width="4" height="22" rx="1" transform="rotate(-45 25 31)" fill="#D4AF37" />
            <path d="M38 26L42 22L46 26L42 30L38 26Z" fill="#FFFFFF" />
            <rect x="34" y="28" width="4" height="18" rx="1" transform="rotate(45 36 37)" fill="#D4AF37" />
        </svg>
    );


    const faqs = [
        {
            q: "Should I purchase Tenant insurance?",
            a: "We require all our tenants to obtain a renter's liability insurance policy. Additionally, we highly recommend that tenants also obtain coverage for their personal belongings. This is important because if unexpected events, such as a burst water pipe occur, a property owner's home insurance policy will not cover any loss or damage to a tenant's personal belongings."
        },
        {
            q: "How do I pay my rent?",
            a: "Rent can be paid securely through our online Tenant Portal (Yardi). You can set up auto-pay or make one-time payments."
        },
        {
            q: "What constitutes a maintenance emergency?",
            a: "Emergencies include fire, flooding, gas leaks, loss of heat in winter, or any issue that poses an immediate threat to safety or property structure. For emergencies, please call our 24/7 line."
        },
        {
            q: "What are my next steps should I want to end the tenancy?",
            a: "After the conclusion of your one-year tenancy agreement, and you transition to a month-to-month tenancy, you must provide written notice of your intention to vacate at least 60 days in advance to P&C Property Management. This can be done by giving a written notice via email or by filling out the Tenant's Notice to Terminate the Tenancy N9 form."
        },
        {
            q: "Who can I turn to, to learn my rights as a tenant?",
            a: "The Ontario Landlord and Tenant Board is an excellent source of information regarding all aspects of renting in Ontario."
        },
        {
            q: "How do I apply for a rental?",
            a: "First, view the property. Then, complete the online application via the link provided below. You'll need proof of income and references."
        }
    ];

    return (
        <div className="tenants-page">
            <div className="page-header">
                <div className="container">
                    <h1>Tenants & Resources</h1>
                    <p>Everything you need to manage your residency.</p>
                </div>
            </div>

            <div className="container section">

                {/* Tenant Portal Section */}
                <div className="resource-section portal-section text-center">
                    <PortalIcon />
                    <h2>Tenant Portal</h2>
                    <p>Access your account to pay rent, submit maintenance requests, and view documents.</p>
                    <a href="#" className="btn-primary" target="_blank" rel="noopener noreferrer">Log In to Tenant Portal</a>

                </div>

                <div className="resource-grid">
                    {/* Application Instructions */}
                    <div className="resource-card application-card">
                        <ApplicationIcon />
                        <h3>Future Residents</h3>
                        <p>Interested in one of our managed properties? Here is how to apply:</p>
                        <ol>
                            <li>Schedule a viewing of the property.</li>
                            <li>Complete the Online Application Form.</li>
                            <li>Submit required documents (ID, Proof of Income).</li>
                            <li>Wait for approval (typically 24-48 hours).</li>
                        </ol>
                        <button className="btn-secondary">Start Application</button>
                    </div>

                    {/* Maintenance Request Preview */}
                    <div className="resource-card maintenance-card">
                        <MaintenanceIcon />
                        <h3>Maintenance Requests</h3>
                        <p>Need a repair? The fastest way is through the Tenant Portal.</p>
                        <p>For non-emergency issues, you can also use our quick request form below.</p>
                        <form className="maintenance-quick-form" onSubmit={handleSubmit}>
                            {/* Hidden Configuration Fields for FormSubmit */}
                            <input type="hidden" name="_subject" value="URGENT: Maintenance Request" />
                            <input type="hidden" name="_cc" value="p.cpropservices@gmail.com" />
                            <input type="hidden" name="_captcha" value="false" />
                            <input type="hidden" name="_template" value="table" />
                            <input type="text" name="user_name" placeholder="Your Name" className="form-input" required />
                            <input type="text" name="property_address" placeholder="Property Address" className="form-input" required />
                            <textarea name="message" placeholder="Describe the issue..." className="form-input" required></textarea>
                            <button className="btn-primary full-width" disabled={status === 'sending'}>
                                {status === 'sending' ? 'Sending...' : 'Submit Request'}
                            </button>
                            {status === 'success' && <p className="success-message" style={{ color: 'green', marginTop: '10px', fontSize: '0.9rem' }}>Request submitted successfully!</p>}
                            {status === 'error' && <p className="error-message" style={{ color: 'red', marginTop: '10px', fontSize: '0.9rem' }}>Failed to submit. Please try again.</p>}
                        </form>
                        <p className="emergency-note"><strong>For Emergencies:</strong> Call +1 (226) 927-5757</p>
                    </div>
                </div>



                {/* Visual Break Placeholder */}
                <div className="visual-break-placeholder">
                    <img src={tenantsVisualBreak} alt="Happy Residents" className="visual-break-image" />
                </div>

                {/* FAQs */}
                <div className="faq-section">
                    <h2 className="text-center">Frequently Asked Questions</h2>
                    <div className="faq-list">
                        {faqs.map((faq, index) => (
                            <div
                                key={index}
                                className={`faq-item ${activeIndex === index ? 'active' : ''}`}
                                onClick={() => toggleFAQ(index)}
                            >
                                <div className="faq-question">
                                    <h4>{faq.q}</h4>
                                    <span className="faq-toggle">
                                        {activeIndex === index ? '−' : '+'}
                                    </span>
                                </div>
                                <div className="faq-answer">
                                    <p>{faq.a}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

            </div>
        </div>
    );
};

export default Tenants;
